import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { FRONTEND_ASSET_HOST } from '#src/constants/assets.ts';

import type { getDeliverableItemImageUrl_deliverableItem } from './__generated__/deliverableItem.graphql.ts';
import { isType, withFragments } from './gql/index.ts';

const DELIVERABLE_ITEM_IMAGE_URL = `${FRONTEND_ASSET_HOST}/rewards/`;

export const getDeliverableItemImageUrl = withFragments(
  (deliverableItem: getDeliverableItemImageUrl_deliverableItem) => {
    let url = '';
    if (isType(deliverableItem, 'JerseyDeliverableItem')) {
      url = `jersey`;
    }
    if (isType(deliverableItem, 'WearableDeliverableItem')) {
      url = `hat`;
    }
    if (isType(deliverableItem, 'ExperienceDeliverableItem')) {
      url = `experience`;
    }
    if (isType(deliverableItem, 'TicketsDeliverableItem')) {
      url = `ticket`;
    }
    return `${DELIVERABLE_ITEM_IMAGE_URL}${url}.png`;
  },
  {
    deliverableItem: gql`
      fragment getDeliverableItemImageUrl_deliverableItem on DeliverableItemInterface {
        slug
      }
    ` as TypedDocumentNode<getDeliverableItemImageUrl_deliverableItem>,
  }
);
